<template>
  <TopNav></TopNav>
  <h1>Force Calculator</h1>
  <fieldset>
    <legend>Force Calculator</legend>
    <label for="a">Mass: </label> <input type="number" v-model.number="mass" id="a" step="any"> ㎏
    <br>
    <label for="b">Acceleration: </label> <input type="number" v-model.number="acceleration" id="b" step="any"> m/s<sup>2</sup>
    <br><br>
    Force = <span class="blue">{{ force() }} N</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Force",
  data() {
    return {
      formatter: Intl.NumberFormat('en-US', {
        maximumFractionDigits: 5
      }),
      mass: 100,
      acceleration: 10,
    }
  },
  components: {
    TopNav
  },
  methods: {
    force: function () {
      let force = this.mass * this.acceleration;
      return this.formatter.format(force);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 115px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
